import React from "react"
import Base from "./Base"
import { Card, Row, Col, Table, Typography, Spin } from "antd"
import { Auth, API } from "aws-amplify"
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
const { Text } = Typography;

class Taxes extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            loading: true,
            tax_data:{},
            user:{},
        };
        }

        componentDidMount() {
            if (this.props.login.user_data.estado_usuario ==='INACTIVO'|| this.props.login.user_data.estado_usuario === 'INCOMPLETO'){
                this.props.history.push('/')
            }else{
            Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/dashboard',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                .then(response => {
                    this.setState({tax_data: response['dashboard'], loading:false, user:response['user']})
                })
                .catch(err => console.log(err))
            })
        }
    }

        render() {
            if (this.state.loading){
                return(
                <Base
                title="Mis Impuestos"
                selected="impuestos"
            >
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                <Col style={{minHeight:'360px'}}>
                    <Spin indicator={CustomSpinner}/>
                </Col>
            </Row>
            <Row></Row>
                </Base>)
            }
            else{

        let columns = [
            {
                title: 'Descripción',
                dataIndex: 'descripcion',
                key: 'descripcion',
            },
            {
                title: 'Valor',
                dataIndex: 'valor',
                key: 'valor',
            }
        ];

let totalMono = this.state.tax_data.cuota_actividad + this.state.tax_data.cuota_sipa + this.state.tax_data.cuota_os
        let dataMonotributo = [
            {
                key: '1',
                descripcion: 'Categoría',
                valor: this.state.tax_data.monotributo_categoria
            },
            {
                key: '2',
                descripcion: 'Próximo Vencimiento',
                valor: this.state.tax_data.monotributo_vto
            },
            {
                key: '3',
                descripcion: 'Aporte Obra Social',
                valor: '$ '+(this.state.tax_data.cuota_os === null?'0':(this.state.tax_data.cuota_os).toLocaleString())
            },
            {
                key: '4',
                descripcion: 'Aporte Jubilación',
                valor: '$ '+(this.state.tax_data.cuota_sipa === null?'0':(this.state.tax_data.cuota_sipa).toLocaleString())
            },
            {
                key: '5',
                descripcion: 'Aporte Actividad',
                valor: '$ '+(this.state.tax_data.cuota_actividad ===null ?'0':(this.state.tax_data.cuota_actividad).toLocaleString())
            },
            {
                key: '6',
                descripcion: 'Total Cuota',
                valor: '$ '+(totalMono === null?'0':totalMono.toLocaleString())
            }
        ];

        let dataiibb = [
            {
                key: '1',
                descripcion: 'Categoría',
                valor: this.state.tax_data.iibb_categoria
            },
            {
                key: '2',
                descripcion: 'Próximo día de vencimiento',
                valor: this.state.tax_data.iibb_vto
            },
            {
                key: '3',
                descripcion: 'Cuota Mensual',
                valor: '$ '+this.state.tax_data.iibb_monto
            }

        ];

        return (

            <Base
                title="Mis Impuestos"
                selected="impuestos"
            >
                <Row gutter={[8, 8]}>
                    <Col lg={8}>
                        <Card
                            title={'Monotributo'}
                            style={{ marginBottom: 10}}
                        >
                            <Table dataSource={dataMonotributo} columns={columns} pagination={false} showHeader={false} />
                        </Card>
                    </Col>
                    <Col lg={8}>
                        <Card
                            title={'Ingresos Brutos'}
                            style={{ marginBottom: 10}}
                        >
                        {this.state.tax_data.iibb_categoria==null?<Text>No estas inscripto en este impuesto. Tenés dudas? Escribinos por chat.</Text>:<Table dataSource={dataiibb} columns={columns} pagination={false} showHeader={false} />}
                        </Card>
                    </Col>
                </Row>
            </Base>

        );
    }}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Taxes));